import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { MainComponent } from './main/main.component';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { AdvanceCostsComponent } from './main/advance/costs/advance-costs.component';
import { CostComponent } from './main/cost/cost.component';
import { PageNotFoundComponent } from './error-pages/404/page-not-found.component';
import { PasswordComponent } from './auth/login/password/password.component';
import { ProfileComponent } from './main/profile/profile.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { NewPasswordComponent } from './auth/login/new-password/new-password.component';
import { EmployeesComponent } from './main/employees/employees.component';
import { EmployeeComponent } from './main/employee/employee.component';
import { DelegationsComponent } from './main/delegations/delegations.component';
import { AuthGuardService } from './shared/guards/auth-guard.service';
import { AdvancesComponent } from './main/advances/advances.component';
import { AdvanceComponent } from './main/advance/advance.component';
import { AdvancesEmployeesComponent } from './main/advances/employees/advances-employees.component';
import { AdvancesCostsComponent } from './main/advances/costs/advances-costs.component';
import { CostsComponent } from './main/costs/costs.component';
import { DelegationComponent } from './main/delegation/delegation.component';
import { CostPrintComponent } from './main/cost/cost-print/cost-print.component';
import { DelegationsEmployeesComponent } from './main/delegations/employees/delegations-employees.component';
import { AdvancesEmployeesArchivesComponent } from './main/advances/employees/archives/advances-employees-archives.component';
import { AdvancesArchivesComponent } from './main/advances/archives/advances-archives.component';
import { PageForbiddenComponent } from './error-pages/403/page-forbidden/page-forbidden.component';
import { AdvanceEditComponent } from './main/advance/edit/advance-edit.component';
import { EmployeeDelegationsComponent } from './main/delegations/employee-delegations/employee-delegations.component';
import { EmployeeCostsComponent } from './main/costs/employee-costs/employee-costs.component';
import { DelegationAddComponent } from './main/delegation/add/delegation-add.component';
import { CostAddComponent } from './main/cost/cost-add/cost-add.component';
import {DelegationsArchivesComponent} from './main/delegations/archives/delegations-archives.component';
import { AuctionIframeComponent } from './test/auction-iframe/auction-iframe.component';
import { KsefGeneralListComponent } from './main/ksef/pages/ksef-general-list/ksef-general-list.component';
import { KsefMyListComponent } from './main/ksef/pages/ksef-my-list/ksef-my-list.component';
import { KsefInCirculationListComponent } from './main/ksef/pages/ksef-in-circulation-list/ksef-in-circulation-list.component';
import { KsefCancelledListComponent } from './main/ksef/pages/ksef-cancelled-list/ksef-cancelled-list.component';
import { FeatureFlagGuard } from './shared/guards/feature-flag.guard';
import { KsefHrnestSettledListComponent } from './main/ksef/pages/ksef-hrnest-settled-list/ksef-hrnest-settled-list.component';
import { SettingsComponent } from './main/settings/settings.component';
import { TwoFactorVerifyComponent } from './auth/two-factor/two-factor-verify.component';
import { TwoFactorSetupPageComponent } from './auth/two-factor/two-factor-setup-page.component';
import { TwoFactorSettingsComponent } from './main/security/two-factor-settings.component';

const routes: Routes = [
  {
    path: '', component: MainComponent, canActivateChild: [AuthGuardService],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'finances', component: AdvancesComponent },
      { path: 'finances/:advanceType', component: AdvancesComponent },
      { path: 'archives', component: AdvancesArchivesComponent },
      { path: 'advances', component: AdvancesComponent },
      { path: 'advances/costs/:costStatus', component: AdvancesCostsComponent },
      { path: 'advances/employees/active', component: AdvancesEmployeesComponent },
      { path: 'advances/employees/inactive', component: AdvancesEmployeesArchivesComponent },
      { path: 'advances/employees', redirectTo: '/advances/employees/active' },
      { path: 'advance/add', component: AdvanceComponent },
      { path: 'advance/:id', component: AdvanceComponent },
      { path: 'advance/:id/costs', redirectTo: 'advance/:id/costs/progress' },
      { path: 'advance/:advanceId/costs/:costStatusTab', component: AdvanceCostsComponent },
      { path: 'advance/:id/edit', component: AdvanceEditComponent },
      { path: 'costs', redirectTo: 'costs/approved' },
      { path: 'costs/:costStatus', component: CostsComponent },
      // { path: 'advance/:id/costs/approved', component: CostsComponent },
      // { path: 'advance/:id/costs/rejected', component: CostsComponent },
      // { path: 'advance/:id/costs/canceled', component: CostsComponent },
      { path: 'delegates', component: DelegationsComponent },
      { path: 'delegations/employees', component: DelegationsEmployeesComponent },
      { path: 'delegations/archives', component: DelegationsArchivesComponent },
      // { path: 'delegation/add', component: DelegationComponent },
      { path: 'delegation/add', component: DelegationAddComponent },
      { path: 'delegation/:id', component: DelegationComponent },
      { path: 'cost/add', component: CostAddComponent },
      { path: 'cost/:id', component: CostComponent },
      // { path: 'cost/archive/:id', component: CostComponent },
      // { path: 'cost/modify/:id', component: CostComponent },
      { path: 'dashboard', component: DashboardComponent },
      // { path: 'company', redirectTo: 'company/dashboard' },
      // { path: 'company/employees', component: EmployeesComponent },
      // TODO: I've removed /company subroute for employee for now. We have to think about that. It could be helpful when there'd be more companies eg. /company/1/employee/1
      { path: 'employee/add', component: EmployeeComponent },
      { path: 'employee/:id', component: EmployeeComponent },
      { path: 'employee/:id/advances', component: AdvancesComponent },
      { path: 'employee/:id/costs/:costStatusTab', component: EmployeeCostsComponent },
      { path: 'employee/:id/delegations', component: EmployeeDelegationsComponent },
      { path: 'employees', component: EmployeesComponent },
      { path: 'ksef', component: KsefGeneralListComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'KSEF_MODULE' } },
      { path: 'ksef/my', component: KsefMyListComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'KSEF_MODULE' } },
      { path: 'ksef/in-circulation', component: KsefInCirculationListComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'KSEF_MODULE' } },
      { path: 'ksef/cancelled', component: KsefCancelledListComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'KSEF_MODULE' } },
      { path: 'ksef/hrnest-settled', component: KsefHrnestSettledListComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'KSEF_MODULE' } },
      { path: 'test/auction-iframe', component: AuctionIframeComponent },
      // { path: 'profile', component: ProfileComponent },
      // { path: 'profile/:id', component: ProfileComponent },
      // { path: 'profile/new', component: ProfileComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'security', component: TwoFactorSettingsComponent },
      // { path: '**', component: PageNotFoundComponent }
    ]
  },
  { path: 'print/costs', component: CostPrintComponent, canActivate: [AuthGuardService] },
  { path: 'login', component: LoginComponent },
  { path: 'login/2fa', component: TwoFactorVerifyComponent },
  { path: 'login/2fa/setup', component: TwoFactorSetupPageComponent },
  { path: 'login/password', component: PasswordComponent },
  // { path: 'login/new/password', component: NewPasswordComponent },
  { path: 'login/new/password/:token', component: NewPasswordComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '403', component: PageForbiddenComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
